import webp from './quotes-dr-love-catriona.webp';
import jpg from './quotes-dr-love-catriona.jpg';

export default [webp, jpg];
